import TimePresets from '../components/quick/TimePresets';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Select from 'react-select';
import { BsClock, BsCheckCircle } from 'react-icons/bs';
import { apiFetch, parseJsonSafe } from '../utils/api';

const ProjectTasksPage = () => {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [project, setProject] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [timeModal, setTimeModal] = useState({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: new Date().toISOString().slice(0, 10) });
  const [savingTime, setSavingTime] = useState(false);

  const handleUnauthorized = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  };

  const fetchProject = async () => {
    try {
      const res = await apiFetch(`/api/projects/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo cargar el proyecto');
      setProject(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchTasks = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch(`/api/projects/${id}/tasks`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudieron cargar las tareas');
      setTasks(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await apiFetch('/api/users', { headers: { Authorization: `Bearer ${token}` } });
      const data = await parseJsonSafe(res);
      if (res.ok && Array.isArray(data)) setUsers(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProject();
    fetchTasks();
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const markDone = async (task) => {
    try {
      const res = await apiFetch(`/api/tasks/${task.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        // Enviamos la tarea completa: el PUT no hace COALESCE de client_id/user_id/comentarios
        body: JSON.stringify({
          titulo: task.titulo,
          client_id: task.client_id,
          importance: task.importance,
          user_id: task.user_id,
          estado: 'realizada',
          comentarios: task.comentarios,
          workload: task.workload,
          project_id: task.project_id
        })
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'No se pudo actualizar');
      fetchTasks();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2 className="mb-0">Tareas del proyecto</h2>
          {project && (
            <div className="text-muted">
              {project.titulo} {project.client_name ? `· ${project.client_name}` : ''} ·{' '}
              {project.estado ? project.estado.replace(/_/g, ' ') : ''}
            </div>
          )}
        </div>
        <div className="d-flex gap-2">
          <Link className="btn btn-outline-secondary" to="/proyectos">Volver a proyectos</Link>
          <Link className="btn btn-primary" to={`/tareas?projectId=${id}&create=1`}>Crear tarea</Link>
        </div>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div className="row g-3">
          {tasks.length ? tasks.map((t) => (
            <div key={t.id} className="col-md-4">
              <div className="card shadow-sm h-100" style={{ borderTop: `4px solid ${t.importance === 'alta' ? '#dc3545' : t.importance === 'media' ? '#fd7e14' : '#ffc107'}` }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <h5 className="card-title mb-0"><Link to={`/tareas?taskId=${t.id}`}>{t.titulo}</Link></h5>
                    <span className="badge bg-light text-dark">{t.estado}</span>
                  </div>
                  <div className="text-muted small mt-1">{t.user_name || t.user_email || 'Sin asignar'}</div>
                  {t.comentarios && <div className="small mt-2" style={{ whiteSpace: 'pre-wrap' }}>{t.comentarios}</div>}
                  <div className="d-flex gap-2 mt-3">
                    <button className="btn btn-sm btn-outline-success d-flex align-items-center gap-1" onClick={() => markDone(t)}>
                      <BsCheckCircle /> Realizada
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                      onClick={() => setTimeModal({ open: true, task: t, hours: 1, minutes: 0, comments: '', user_id: t.user_id || null, date: new Date().toISOString().slice(0, 10) })}
                    >
                      <BsClock /> Tiempo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )) : <p>No hay tareas asociadas.</p>}
        </div>
      )}

      {timeModal.open && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.4)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Tiempo dedicado - {timeModal.task?.titulo}</h5>
                <button className="btn-close" onClick={() => setTimeModal({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: new Date().toISOString().slice(0, 10) })}></button>
              </div>
              <div className="modal-body">
                <TimePresets onChange={(hours, minutes) => setTimeModal((p) => ({ ...p, hours, minutes }))} />
                <div className="row g-2 mb-2">
                  <div className="col-12">
                    <label className="form-label">Fecha</label>
                    <input type="date" className="form-control" value={timeModal.date} onChange={(e) => setTimeModal((p) => ({ ...p, date: e.target.value }))} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Horas</label>
                    <input type="number" min="0" className="form-control" value={timeModal.hours} onChange={(e) => setTimeModal((p) => ({ ...p, hours: Number(e.target.value) }))} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Minutos</label>
                    <input type="number" min="0" max="59" className="form-control" value={timeModal.minutes} onChange={(e) => setTimeModal((p) => ({ ...p, minutes: Number(e.target.value) }))} />
                  </div>
                </div>
                <div className="mb-2">
                  <label className="form-label">Comentarios</label>
                  <textarea className="form-control" rows="3" value={timeModal.comments} onChange={(e) => setTimeModal((p) => ({ ...p, comments: e.target.value }))} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Usuario</label>
                  <Select
                    options={users.map((u) => ({ value: u.id, label: u.name || u.email }))}
                    value={users.map((u) => ({ value: u.id, label: u.name || u.email })).find((o) => o.value === timeModal.user_id) || null}
                    onChange={(opt) => setTimeModal((p) => ({ ...p, user_id: opt ? opt.value : null }))}
                    placeholder="Selecciona usuario"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setTimeModal({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: new Date().toISOString().slice(0, 10) })}>Cerrar</button>
                <button
                  className="btn btn-primary"
                  disabled={savingTime}
                  onClick={async () => {
                    const mins = Number(timeModal.hours) * 60 + Number(timeModal.minutes || 0);
                    if (!mins) return alert('Tiempo debe ser mayor que 0');
                    setSavingTime(true);
                    try {
                      const res = await apiFetch(`/api/tasks/${timeModal.task.id}/time`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify({
                          minutes: mins,
                          comments: timeModal.comments,
                          user_id: timeModal.user_id,
                          date: timeModal.date || new Date().toISOString().slice(0, 10)
                        })
                      });
                      const data = await parseJsonSafe(res);
                      if (res.status === 401) return handleUnauthorized();
                      if (!res.ok) throw new Error(data.message || 'No se pudo guardar');
                      setTimeModal({ open: false, task: null, hours: 1, minutes: 0, comments: '', user_id: null, date: new Date().toISOString().slice(0, 10) });
                    } catch (err) {
                      alert(err.message);
                    } finally {
                      setSavingTime(false);
                    }
                  }}
                >
                  {savingTime ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectTasksPage;
